import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Switch, Route } from "react-router-dom";
import { MDBBtn, MDBIcon } from "mdbreact";
import { API } from "aws-amplify";
import { selectStaff, updateStaffDetails } from "../../actions/staffActions";
import { setLoaderState } from "../../actions/loaderActions";

class StaffDetailsSelected extends Component {
  async componentDidMount() {
    try {
      this.props.dispatch(setLoaderState(true));
      const { staffId } = this.props.match.params;
      if (!this.props.id) {
        const response = await API.get("telishadeAPI", "/staff/" + staffId);
        this.props.dispatch(updateStaffDetails(response.details));
        this.props.dispatch(selectStaff(staffId));
      }
    } catch (error) {
      // If the staff didn't exist, then redirect back
      if (error.response && error.response.status === 404) {
        this.props.history.replace("/staff/");
      }
    } finally {
      this.props.dispatch(setLoaderState(false));
    }
  }

  render() {
    return (
      <div className="staff-details-panel">
        <div className="staff-header">
          <h2>{this.props.details.name}</h2>
        </div>
        {!this.props.details.name ? (
          ""
        ) : (
          <span>
            <strong>Company Registration No.: </strong>{" "}
            {this.props.details.regNo}
            <br />
            <strong>Email:</strong> {this.props.details.email}
            <br />
            <strong>Phone: </strong> {this.props.details.phone}
            <br />
            <strong>Website: </strong> {this.props.details.website}
            <br />
            <strong>fax: </strong> {this.props.details.fax}
            <br />
            <strong>Mobile: </strong> {this.props.details.mobile}
            <br />
            <div id="editButton">
              <MDBBtn
                onClick={() =>
                  this.props.history.push(
                    `/staff/${this.props.match.params.staffId}/edit`
                  )
                }
                color="blue"
                id="custEditBtn"
              >
                Edit
              </MDBBtn>
              <MDBBtn
                onClick={() =>
                  this.props.history.push(
                    `/staff/${this.props.match.params.staffId}/delete`
                  )
                }
                color="red"
                id="custDeleteBtn"
              >
                <MDBIcon icon="trash" />
              </MDBBtn>
            </div>
          </span>
        )}
      </div>
    );
  }
}

class StaffDetails extends Component {
  render() {
    return (
      <Switch>
        <Route path="/staff/add" />
        <Route
          path="/staff/:staffId"
          render={routeProps => (
            <StaffDetailsSelected {...this.props} {...routeProps} />
          )}
        />
        <Route path="/staff/">
          <div className="staff-details-panel">
            <div className="staff-header">
              <h2>Select a Staff Member</h2>
            </div>
          </div>
        </Route>
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return state.staff.staff;
};

export default withRouter(connect(mapStateToProps)(StaffDetails));
